import scrollToSection from '../utils/scrollToSection';
import { QUOTE_MESSAGE } from '../data/Contact';

const CONTACT_PREFILL_EVENT = 'contact-prefill-message';

/**
 * Triggers a global event to prefill the contact form message.
 * @param {string} message - The message to prefill.
 */
export function prefillContactMessage(message = QUOTE_MESSAGE) {
  const event = new CustomEvent(CONTACT_PREFILL_EVENT, {
    detail: { message },
  });
  window.dispatchEvent(event);
  scrollToSection('contact-container');
}

/**
 * Allows the Contact component to listen for prefill events.
 * @param {function} callback - Function to call when message should be prefilled.
 * @returns {function} Cleanup function to remove listener.
 */
export function subscribeToPrefillMessage(callback) {
  const handler = (event) => {
    const { message } = event.detail;
    callback(message);
  };

  window.addEventListener(CONTACT_PREFILL_EVENT, handler);

  // Return cleanup function
  return () => window.removeEventListener(CONTACT_PREFILL_EVENT, handler);
}
